/** @module Sourcing/ColorSizeCodesMatrix */
define([
	"dojo/_base/declare",
	"underscore",
	"csi/locale",
	"csi/table/matrix/Path"
], function(declare, _, locale, Path) {

	/**
	 * This unit is used to create Matrix on ProductSuppliers views (view type is ProductSource).
	 * Matrix shows combination of ColorNames and ProductSupplier.ColorCodes, as well as SizeNames/ProductSupplier.SizeCodes
	 */
	return declare(Path, {
		/** @property {string} colorSizeCodesId - heading id for supplier code (ColorCodes/SizeCodes) matrix column, to be specified in Mmodule XML */
		//colorSizeCodesId: "",

		/** @property {string} productColorsSizesPath - path to the Color/Size name node, to be specified in Module XML */
		//productColorsSizesPath: "",

		/**
		 * @override
		 * Create array of Client (virtual) nodes
		 */
		_getRowNodes: function(ctx, qr, c, node) {
			var codeNodes = ctx.cache.getPathNodes(node, this.productColorsSizesPath);
			var nodes = _.map(codeNodes, function(codeNode) {
				var clientNode = ctx.cache.createClientNode(null, "Code", codeNode.$Name);
				clientNode.SysID = codeNode.SysID;
				clientNode.ProductSourceUrl = node.$URL;
				clientNode.Ref = codeNode.$URL;
				clientNode.ColorCodes = node.ColorCodes[codeNode.SysID];
				clientNode.SizeCodes = node.SizeCodes[codeNode.SysID];
				return clientNode;
			});
			nodes = ctx.view.applyMatrixAdHocFilters(qr, c, nodes);
			return nodes;
		},

		/**
		 * @override
		 * For ColorCodes/SizeCodes create array of SysIDs for given matrix column to apply with spec to given nodes
		 */
		_getSpecIndices: function(ctx, spec, nodes) {
			if (nodes.length && (spec.heading.m_id == this.colorSizeCodesId)) {
				ctx.setReadOnly(false);
				return _.map(nodes, function(node) {
					return node.SysID;
				});
			}
			return null;
		},

		/**
		 * @override
		 * For create array of nodes that match current row and column
		 */
		_getSpecNodes: function(ctx, spec, nodes) {
			if (nodes.length && (spec.heading.m_id == this.colorSizeCodesId)) {
				var node = ctx.cache.getNode(nodes[0].ProductSourceUrl);
				return Array(nodes.length).fill(node);
			} else {
				return _.map(nodes, function(clientNode) {
					return ctx.cache.get(clientNode.Ref);
				});
			}
		},

		/**
		 * @override
		 * Disable filtering for Product Color and Product Size columns
		 */
		_getColumnSubQuerySpec: function(ctx, spec) {
			return spec.heading.m_id ? this.inherited(arguments) : null;
		},
	});
});